module.exports = __webpack_public_path__ + "img/P0-en.81f15f8a.png";